//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/SelectFace.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[0,"AllFaces",1,0],[1,"ConformalCoolingBody",0,"ScCollector",0],[0,"DisplayColor",1,0],[0,"DisplayEntity",1,0],[0,"DisplayMode",1,0],[0,"DisplayResolution",1,0],[0,"DisplayTranslucency",1,0],[1,"DynamicPointOnFace",0,"SelectFace",0],[1,"FacesToDisplay",0,"ScCollector",0],[0,"OffsetDistance",1,0],[0,"SaveConvergentBody",1,0]],[[[],"CreateOffsetConvergentBody",{},0,0],[[],"CreateConvergentBody",{},0,0],[[],"GetInApplyStatus",{R_:{inApplyStatus:''}},0,0],[["inApplyStatus"],"SetInApplyStatus",{},1,0],[["changingBody"],"InitConformalCoolingFacetsData",{},1,0],[[],"UpdateFacetsDisplay",{},0,0],[[],"GetInUnitTest",{R_:{inUnitTest:''}},0,0],[["inUnitTest"],"SetInUnitTest",{},1,0]],[]];
SPLM.Tooling.ConformalCoolingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ConformalCoolingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ConformalCoolingBuilder.DisplayResolutionOption = Object.freeze({
    "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine", "SuperFine" : "SuperFine", "UltraFine" : "UltraFine"});

SPLM.Tooling.ConformalCoolingBuilder.DisplayEntityType = Object.freeze({
    "Facet" : "Facet", "BoundaryCube" : "BoundaryCube", "OffsetLayerCube" : "OffsetLayerCube", "InnerCube" : "InnerCube"});

SPLM.Tooling.ConformalCoolingBuilder.DisplayModeType = Object.freeze({
    "Wireframe" : "Wireframe", "Colorfill" : "Colorfill", "Both" : "Both"});

export default SPLM;